<script setup lang="ts">
import { getCurrentInstance, computed } from 'vue';

const uid = getCurrentInstance()!.uid;

const filter0 = computed(() => `filter0_d_${uid}`);
const paint0 = computed(() => `paint0_linear_${uid}`);
</script>

<template>
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect fill="white" />

    <g :filter="`url(#${filter0})`">
      <path
        d="M22.0886 8.40778C22.814 6.73511 25.186 6.73511 25.9114 8.40778L28.9418 15.3962C29.2437 16.0924 29.9002 16.5694 30.6555 16.6414L38.2384 17.3639C40.0534 17.5369 40.7864 19.7928 39.4197 20.9996L33.7098 26.0412C33.141 26.5435 32.8902 27.3152 33.0552 28.0559L34.7112 35.4909C35.1076 37.2705 33.1885 38.6647 31.6186 37.7378L25.0592 33.8653C24.4057 33.4795 23.5943 33.4795 22.9408 33.8653L16.3814 37.7378C14.8115 38.6647 12.8924 37.2705 13.2888 35.4909L14.9448 28.0559C15.1098 27.3152 14.859 26.5435 14.2902 26.0412L8.58027 20.9996C7.21361 19.7928 7.94662 17.5369 9.76156 17.3639L17.3445 16.6414C18.0998 16.5694 18.7563 16.0924 19.0582 15.3963L22.0886 8.40778Z"
        :fill="`url(#${paint0})`"
      />
    </g>

    <defs>
      <filter
        :id="filter0"
        x="4.54167"
        y="7.15234"
        width="38.9167"
        height="37.5456"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3.33333" />
        <feGaussianBlur stdDeviation="1.66667" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.98 0 0 0 0 0.494083 0 0 0 0 0.147 0 0 0 0.3 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
      </filter>

      <linearGradient :id="paint0" x1="24" y1="4" x2="24" y2="44" gradientUnits="userSpaceOnUse">
        <stop stop-color="#F2BA00" />
        <stop offset="1" stop-color="#FA7E25" />
      </linearGradient>
    </defs>
  </svg>
</template>
